export default "__VITE_ASSET__D$hQsbk6__"